import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { type ComponentProps } from "react";

import { MenuItem, type MenuItemProps } from "../menu-item";

export type DropdownMenuRadioItemProps = ComponentProps<typeof DropdownMenuPrimitive.RadioItem> &
  Pick<MenuItemProps, "shortcut">;

export const RadioItem = ({ ref, className, children, shortcut, onSelect, ...props }: DropdownMenuRadioItemProps) => (
  <DropdownMenuPrimitive.RadioItem
    ref={ref}
    // Picking keeps the menu open, as for a checkbox item.
    onSelect={event => {
      event.preventDefault();
      onSelect?.(event);
    }}
    {...props}
    asChild
  >
    <MenuItem variant="radio" shortcut={shortcut} className={className}>
      {children}
    </MenuItem>
  </DropdownMenuPrimitive.RadioItem>
);

RadioItem.displayName = DropdownMenuPrimitive.RadioItem.displayName;
